import React from 'react'
import './loader.css'

function Loader() {
    return (
        <div className="progress-wrap">
            <div className="progress">
                <div className="color"></div>
            </div>
        </div>
    )
}

export default Loader;